<dialog-header
  [title]="dialogTitle"
  (onClose)="matDialogRef.close()"
></dialog-header>

<div
  mat-dialog-content
  style="
    padding-bottom: 20px;
    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    background-color: var(--app-container);
  "
>
  <form [formGroup]="form" style="margin-top: 20px">
    <!-- Title -->
    <div class="form-field" style="margin-bottom: 20px">
      <div class="form-field-label">Title<span style="color: red">*</span></div>
      <input
        class="form-input"
        autocomplete="off"
        [placeholder]="titlePlaceholder"
        [maxlength]="20"
        [formControl]="titleFormControl"
        type="text"
      />
    </div>

    <!-- Description -->
    <div class="form-field" style="margin-bottom: 20px">
      <div class="form-field-label">
        Description<span style="color: red">*</span>
      </div>
      <input
        class="form-input"
        autocomplete="off"
        [placeholder]="descriptionPlaceholder"
        [maxlength]="200"
        [formControl]="descriptionFormControl"
        type="text"
      />
    </div>

    <!-- Points Awarded -->
    <div class="form-field" style="margin-bottom: 20px">
      <div class="form-field-label">
        Points Awarded<span style="color: red">*</span>
      </div>
      <input
        class="form-input"
        autocomplete="off"
        placeholder="e.g. 50"
        [formControl]="pointsAwardedFormControl"
        type="number"
      />
    </div>
  </form>
</div>

<div mat-dialog-actions align="end">
  <app-secondary-button
    style="margin-right: 10px"
    [title]="'Cancel'"
    [disabled]="false"
    (tapped)="matDialogRef.close()"
  ></app-secondary-button>

  <app-primary-button
    [title]="isEditing ? 'Update' : 'Add'"
    [disabled]="false"
    (tapped)="primaryTapped()"
    bgColor="var(--app-timber)"
    color="white"
  ></app-primary-button>
</div>
